import type { ComponentType, ReactNode } from 'react';

type CmpEmbedProviderProps = {
  baseUrl: string;
  children: ReactNode;
  onTokenExpired?: () => void;
  orgSsoId: string;
  token: string;
};

type EmbeddableTaskProps = {
  className?: string;
  defaultTab?: 'content' | 'history';
  onApprove?: () => void;
  onReject?: (reason: string) => void;
  taskId: string;
};

type CmpModules = {
  CmpEmbedProvider: ComponentType<CmpEmbedProviderProps>;
  EmbeddableTask: ComponentType<EmbeddableTaskProps>;
};

// The MFECmp module-federation remote is currently disabled (see rspack.config.js).
// This hook reports the CMP modules as unavailable so consumers fall back gracefully
// instead of attempting to resolve the (absent) `MFECmp/*` remote at runtime.
export function useCmpModules(_load: boolean) {
  return {
    CmpEmbedProvider: undefined as CmpModules['CmpEmbedProvider'] | undefined,
    EmbeddableTask: undefined as CmpModules['EmbeddableTask'] | undefined,
    isLoaded: false,
    error: null as Error | null,
  };
}
